import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';

import axios from 'axios';

import {
  Box,
  Card,
  Button,
	List, 
	ListItem, 
	ListItemText,
  ListItemAvatar,
	ListItemIcon,
  ListItemSecondaryAction,
  Avatar,
  CardHeader,
  CardContent,
  CardActions,
  Divider,
  Typography,
} from '@material-ui/core';

import auth from '../../../../utils/auth';
import EmailIcon from '@material-ui/icons/Email';
import DraftsIcon from '@material-ui/icons/Drafts';

const useStyles = makeStyles(theme => ({
  root: {

  },
  item: {
    display: 'flex',
    flexDirection: 'column'
  },
  cardWrapper: {
    margin: '0 auto',
    maxWidth:'720px'
  },
  invite: {
    background: '#f5f5f5',
    borderRadius: '4px',
    border: '1px #dddddd solid ',
    marginBottom: '12px', 
  },
  list: {
    maxHeight: '480px',
    overflowY: 'auto',
    marginBottom: '12px'
  },
  email: {
    background: '#4db6ac'
  },
  draft: {
    background: '#eeeeee', 
  },
  buttons: {
    textAlign:'center',
    marginBottom:'12px'
  },
  desc: {
    padding:'6px 12px 0px 12px',
    fontSize:'12px'
  },
  icon: {
    color:"#ffffff"
  }
}));


const Invite = props => {
//  const { strava } = props;
  const [inviteList, setInviteList] = useState([]);
  const [newInvite, setNewInvite] = useState(0);
  const [inviteAvailable, setInviteAvailable] = useState(false);

  const classes = useStyles();
	const userInfo = auth.getUserInfo();
  const extraInfo = auth.getExtraInfo();

	const auth_str = 'Bearer '.concat((auth.getToken().token)); 
  const strava_id = extraInfo ? extraInfo.strava_id : 0;

	useEffect(() => {
		if(Number(strava_id) > 0) {
			axios.get(
				`${process.env.REACT_APP_RESTAPI_BASE_URL}/json-api/manage-invite.php`, 
				{
					headers: { Authorization: auth_str }, 
					params: {
						order: 'invite_list'
					}
				}
			).then(function (response) {
				if (response) {
					let res = response.data;   
          setInviteList(res.invite_list);
          setInviteAvailable(res.invite_available);
        }
			}).catch((err) => {
				console.log(err);
			});
		}
  }, [strava_id, newInvite]);


	const handleAddInvite = () => {
//		setActivityReload('loading');	
		const auth_str = 'Bearer '.concat((auth.getToken().token)); 
	
		axios.post(`${process.env.REACT_APP_RESTAPI_BASE_URL}/json-api/manage-invite.php`, 
			{	order : 'add_invite' },
			{ headers: { Authorization: auth_str } }
		).then(function (response) {
			let res = response.data;
			if (res.success === true && res.invite_code) {
				alert('새 초대장이 만들어졌습니다\n' + res.invite_code);
        setNewInvite(1);
      } else  {
        
        if(res.error_code == "week") {
          alert('일주일에 1장만 생성가능합니다');
        } else if(res.error_code == "week_register") {
          alert('가입후 일주일이 지나야 합니다');
        } else if(res.error_code == "no_tss") {
          alert('라이딩 기록이 없습니다');
        } else if(res.error_code == "remain") {
          alert('사용되지 않은 초대장이 있거나\n초대자가 가입과정을 끝내지 않았습니다');
        } else if(res.error_code == "cond") {
          alert('초대장 발행 조건을 확인하세요');
        } else {
          alert('초대장 생성에 실패하였습니다');
        }
			}
		}).catch((err) => {
			console.log(err);
		});
	}

  function InviteList(props) {
    const inviteList = props.inviteList;

    function handleCopyInviteCode(code) {
      navigator.clipboard.writeText(code);    
      alert("초대코드가 복사되었습니다 " + code);
    }
    
    return (
      <React.Fragment>
        {inviteList.map((invite, index) => (
          <ListItem className={classes.invite} key={index}>
            <ListItemAvatar>
              {
              (Number(invite.invitee_id) === 0) ?
                <Avatar className={classes.email}>
                  <EmailIcon className={classes.icon} size="large" />
                </Avatar>
                :
                <Avatar className={classes.draft}>
                  <DraftsIcon className={classes.icon} size="large" />
                </Avatar>
              }
            </ListItemAvatar>
            <ListItemText primary={
              <React.Fragment>
                <Typography component="span">{invite.invite_id}번 초대장</Typography>
                <Typography component="span" style={{marginLeft:'8px'}}>
                </Typography>
              </React.Fragment>
            } secondary={invite.regdate} />

            <ListItemSecondaryAction>
            {
              (Number(invite.invitee_id) === 0) ?
              <Button 
                variant="outlined" 
                color="secondary" 
                edge="end" 
                aria-label="복사" 
                onClick={() => handleCopyInviteCode(invite.invite_code)}
                style={{fontFamily:'Arial'}} 
              >
                {invite.invite_code}
              </Button>
              :
              <Button className={classes.link} edge="end">
                {invite.invitee_name}
              </Button>
            }  
            </ListItemSecondaryAction>

          </ListItem >
        ))}
      </React.Fragment>
    );
  }



	return (
    <Card className={classes.cardWrapper}>
      <form>
        <CardHeader
          title="나의 초대장 목록"
					className={classes.cardHeader}
        />
        <Divider />
        <CardContent>
          <Typography component="div" color="primary" style={{fontSize:'12px',textAlign:'right'}}>
            발행조건 : 없음
          </Typography>

          <List className={classes.list}>
            <InviteList inviteList={inviteList} />
          </List>
          <Box className={classes.buttons}>
            {
              (inviteAvailable === true && extraInfo.ftp > 0) ?
              <Button onClick={handleAddInvite} variant="contained" color="primary" >
                새로운 초대장
              </Button>
              :
              <React.Fragment>
                <Button variant="contained" disabled>
                  새로운 초대장   
                </Button>           
              </React.Fragment>
            }
          </Box>
          <Box className={classes.desc}>
						<div>-파워미터/스마트롤러 사용자만 초대해주세요</div>
						<div>-초대장은 1주일에 1장만 발행됩니다</div>
            <div>-1장당 1명만 가입이 가능합니다</div>
            <div>-이용대상이 아닌 이를 초대하면, 발행이 금지됩니다</div>
            <div>-초대장 발행조건은 주기적으로 변경됩니다</div>
          </Box>
        </CardContent>
        <Divider />
        <CardActions></CardActions>
      </form>
    </Card>
  );
};

Invite.propTypes = {
  className: PropTypes.string
};

export default Invite;
